const data = {
  counterText: 'പരിമിതമായ സ്ലോട്ടുകൾ ലഭ്യമാണ്',
  loading: 'ലോഡിംഗ്',
  next: 'അടുത്തത്',
  previous: 'മുമ്പത്തെ',
  smCounterText: 'പരിമിതമായ സ്ലോട്ടുകൾ അവശേഷിക്കുന്നു',
};

export default data;
